import React from "react"
import Layout from "../components/layout"
import SEO from "../components/seo"
import { ThreeColumnGrid } from "components/ThreeColumnGrid"
import { TeaserBig } from "../components/Teaser_Big"
import { StoriesModule } from "../components/StoriesModule"
import { FindUsModule } from "components/FindUsModule"
import { useStaticQuery, graphql } from "gatsby"
import { ContactPage } from "../components/ContactPage"

const IndexPage = ({ pageContext }) => {
  const { header } = pageContext 

  return (
    <Layout
      title="Contact"
      internal
      headerImg={header ? header.headerImage : false}
    >
      <ContactPage />
    </Layout>
  )
}

export default IndexPage
